<template>
  <div>
    <transition name="slide">
      <div v-if="newVisibleLeft" class="expanded-left-sidebar-div">
        <div
          class="vert-align left-sidebar-sub-item"
          style="border-bottom: 1px solid var(--darkbackground)"
          @click="newVisibleLeft = false"
        ></div>
        <div
          v-for="(item, i) in itemsInformation"
          :key="i"
          class="vert-align sidebar-item"
          :class="getSidebarItemClasses(item)"
          :style="
            item.bdr ||
              (item.itemHeader &&
                'border-bottom: 1px solid var(--darkbackground);')
          "
          @mouseover="onHoverLeftSidebar(item.nameEvent)"
          @mouseleave="onHoverLeftSidebar('')"
          @click="onLeftSidebarAnalysis(item, $event)"
        >
          <div class="sidebar-item-content" :class="getSidebarItemActive(item)">
            {{ item.text }}
            <i
              v-if="item.children"
              :class="{
                'pi pi-angle-right': !expandedItems[item.nameEvent],
                'pi pi-angle-down': expandedItems[item.nameEvent]
              }"
              style="padding-left: 15px;"
            ></i>
          </div>
          <ul
            v-if="item.children && expandedItems[item.nameEvent]"
            class="sidebar-children"
            :ref="el => setSubItemRef(el, item.nameEvent)"
          >
            <li
              v-for="(child, i) in item.children"
              :key="i"
              :class="getSidebarItemClasses(child)"
              @mouseover="onHoverLeftSidebarSubItem(child.nameEvent)"
              @mouseleave="onHoverLeftSidebarSubItem('')"
              @click="onLeftSidebarAnalysis(child, $event)"
            >
              <div
                class="list__line-conections list__line-conections-l"
                v-if="isNonInteractiveElement(child)"
              ></div>
              <div
                :class="{
                  'container-item__active':
                    child.text === selectedChild &&
                    item.nameEvent.includes(newSelectedAnalysisParent)
                }"
              >
                {{ child.text }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </transition>
    <div class="left-sidebar-div">
      <div
        class="justify-content-center vert-align container-left-sidebar-item"
        style="border-bottom: 1px solid var(--darkbackground)"
      >
        <BurgerButton
          :isActive="newVisibleLeft"
          @eventOnUserClick="eventOnUserClick"
        ></BurgerButton>
      </div>
      <div
        v-for="(item, i) in itemsInformation"
        :key="i"
        ref="sidebarItemActive"
        refInFor
        class="justify-content-center vert-align container-left-sidebar-item"
        :class="getSidebarItemActiveSubItem(item)"
        :style="item.bdr && 'border-bottom: 1px solid var(--darkbackground);'"
        @mouseover="onHoverLeftSidebar(item.nameEvent)"
        @mouseleave="onHoverLeftSidebar('')"
        @click="onLeftSidebarAnalysis(item, $event)"
      >
        <template v-if="item.itemHeader">
          {{ item.classNameIcon }}
        </template>
        <template v-else>
          <i :class="item.classNameIcon"></i>
        </template>
        <transition name="appear">
          <div
            v-if="!newVisibleLeft && hoverVariable === item.nameEvent"
            class="vert-align left-sidebar-item-float"
            :style="getItemFloatStyles(item)"
          >
            {{ item.text }}
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import BurgerButton from "@/components/BurgerButton";
import { select, selectAll } from "d3";

export default {
  name: "LeftSideBar",
  components: {
    BurgerButton
  },
  data() {
    return {
      expandedItems: {},
      subItemRefs: {},
      hoveredItem: "",
      pointerEvent: [],
      selectParent: "",
      selectedChild: ""
    };
  },
  props: {
    newVisibleLeft: { required: true, type: Boolean, default: false },
    hoverVariable: { required: true, type: String, default: "" },
    newSelectedAnalysis: { required: true, type: String, default: "" },
    hoverVariableSubItem: { required: true, type: String, default: "" },
    newSelectedAnalysisParent: { required: true, type: String, default: "" },
    itemsInformation: {
      type: Array,
      default: () => [
        {
          text: "",
          nameEvent: "",
          bdr: false,
          itemHeader: false,
          classNameIcon: "",
          bdrTransition: false
        }
      ]
    }
  },
  watch: {
    newVisibleLeft(val) {
      if (!val) {
        this.resetSidebarState();
      }
    }
  },
  methods: {
    resetSidebarState() {
      this.expandedItems = {};
      this.selectedChild = "";
      this.hoveredItem = "";
      this.subItemRefs = {};

      this.$nextTick(() => {
        selectAll(".container-left-sidebar-item")
          .style("height", "100%")
          .style("max-height", "45px");
      });
    },
    onHoverLeftSidebar(val) {
      this.$emit("onHoverLeftSidebar", val);
    },
    onHoverLeftSidebarSubItem(val) {
      this.$emit("onHoverLeftSidebarSubItem", val);
    },
    onHoverSelect(val) {
      this.hoveredItem = val;
    },
    toggleItemExpansion(nameEvent) {
      for (const key in this.expandedItems) {
        if (key !== nameEvent) {
          this.$set(this.expandedItems, key, false);
        }
      }
      const isExpanded = !this.expandedItems[nameEvent];
      this.$set(this.expandedItems, nameEvent, isExpanded);
      this.updateSidebarHeight(nameEvent);
    },
    setSubItemRef(el, nameEvent) {
      if (el) {
        this.$set(this.subItemRefs, nameEvent, el);
        this.updateSidebarHeight(nameEvent);
      }
    },
    updateSidebarHeight(eventName) {
      const isExpanded = this.expandedItems[eventName] || false;
      const allItems = selectAll(".container-left-sidebar-item");
      allItems.style("height", "100%").style("max-height", "45px");

      this.$nextTick(() => {
        if (this.newVisibleLeft && isExpanded) {
          const subItem = select(".left-sidebar-sub-item-active");
          if (!subItem.empty()) {
            const height = subItem.node().getBoundingClientRect().height - 10;

            select(".left-sidebar-item-active")
              .style("height", `${height}px`)
              .style("max-height", `${height}px`);
          }
        }
      });
    },
    onLeftSidebarAnalysis(val, event) {
      this.pointerEvent.push(event);

      if (val.itemHeader) return;

      if (val.children) {
        // Ensure sidebar is open and children are expanded
        if (!this.newVisibleLeft) {
          this.eventOnUserClick(); // Open sidebar
        }
        this.toggleItemExpansion(val.nameEvent); // Expand/collapse children
        const getEvent = this.pointerEvent.findLast(d => d !== "");
        this.$emit("onLeftSidebarAnalysisScenarios", {
          getEvent,
          nameEvent: val.nameEvent
        });

        // if (this.isEventTargetRotated(event)) {
        //   this.eventOnUserClick();
        //   this.toggleItemExpansion(val.nameEvent);
        //   if (this.newVisibleLeft && this.expandedItems[val.nameEvent]) {
        //     // this.toggleItemExpansion(val.nameEvent);
        //   }
        // }
      } else {
        this.$emit("onLeftSidebarAnalysis", {
          val: val.nameEvent,
          parent: val?.nameEventParent
        });
      }
      this.selectedChild = "";
    },
    isEventTargetRotated(event) {
      return (
        event.target.className === "pi pi-align-center fa-rotate-90" ||
        event.target.className === "pi pi-chart-bar"
      );
    },
    eventOnUserClick() {
      this.$emit("eventOnUserClick");
      if (!this.newVisibleLeft) {
        this.expandedItems = {};
      }
    },
    isHovered(nameEvent) {
      return this.hoverVariable === nameEvent;
    },
    isHoveredSubItem(nameEvent) {
      return this.hoverVariableSubItem === nameEvent;
    },
    isSelectedAnalysis(nameEvent) {
      return this.newSelectedAnalysis === nameEvent;
    },
    isSelectedAnalysisParent(nameEvent) {
      return this.newSelectedAnalysisParent === nameEvent;
    },
    getSidebarItemActive(item) {
      const isItemActive =
        this.isHovered(item.nameEvent) ||
        this.isSelectedAnalysis(item.nameEvent) ||
        this.isSelectedAnalysisParent(item.nameEvent);

      if (isItemActive && !item.itemHeader && !item.itemParent) {
        this.selectedChild = item.text;
      }

      return [item.itemHeader ? "" : isItemActive ? "leftSidebarActive" : ""];
    },
    getSidebarSubItemActive(item) {
      return [this.isHoveredSubItem(item.nameEvent) ? "leftSidebarActive" : ""];
    },
    getSidebarItemActiveSubItem(item) {
      const isItemActive = this.expandedItems[item.nameEvent] || false;

      return [
        {
          "left-sidebar-item-active": isItemActive
        },
        this.getSidebarSubItem(item),
        this.getSidebarItemActive(item)
      ];
    },
    getSidebarSubItem(item) {
      const isItemActive = this.expandedItems[item.nameEvent] || false;

      return [
        {
          "left-sidebar-sub-item-active": isItemActive
        }
      ];
    },
    getSidebarItemClasses(item) {
      return [
        this.getSidebarSubItemActive(item),
        this.getSidebarItemActive(item),
        this.getSidebarSubItem(item),
        this.getSidebarLineConnections(item),
        {
          "left-sidebar-sub-item": !item.itemHeader,
          "left-sidebar-item": item.itemHeader
        }
      ];
    },
    getItemFloatStyles(item) {
      return {
        color: item.itemHeader && "var(--textinactive)",
        "border-bottom":
          item.bdr ||
          item.itemHeader ||
          (item.bdrTransition && "1px solid var(--darkbackground)")
      };
    },
    isNonInteractiveElement(child) {
      return child && !child?.children && !child.itemParent;
    },
    getSidebarLineConnections(item) {
      if (this.isNonInteractiveElement(item)) {
        return "position-relative d-flex align-items-center list__line-vertical";
      }
    }
  }
};
</script>

<style scoped>
ul:not(.leftSidebarActive) {
  color: var(--textinactive);
}
.hovered-item {
  color: var(--textactive);
}
.selectActive {
  color: var(--textactive);
}
.sidebar-item-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
}
.left-sidebar-item-active {
  align-items: center;
  justify-content: flex-start !important;
  margin-top: 12px !important;
}
.left-sidebar-sub-item-active {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: auto;
}

.container-left-sidebar-item.left-sidebar-item-active.left-sidebar-sub-item-active {
  align-items: center;
}
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}

.appear-enter-active,
.appear-leave-active {
  transition: opacity 0.5s ease;
}
.appear-enter,
.appear-leave-to {
  opacity: 0;
  transition: all 500ms ease-in 0s;
}
</style>
